import React from 'react';
const NumberOfBookings = ({ data2, data3 }) => {

    return (
        <div className="row">


            <div className="col-lg-6">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className="dash-sub-head">Job Opening</h4>
                        {data2.map((item, index) => (
                            <div className={`card bg_colors 
                                ${item.STATUS === "Closed" ? 'bg-success' :
                                    item.STATUS === "On Hold" ? 'bg-warning' :
                                        item.STATUS === "Open" ? 'bg-danger' : 'bg_color02'}`}
                                key={index}>
                                <div className="card-body">
                                    <div className="box_splite">
                                        <div className="left_splite">
                                            <h3 className="box-head">{item.STATUS}</h3>
                                        </div>
                                        <div className="right_splite">
                                            {item.openings}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="col-lg-6">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className="dash-sub-head">Recruitment Status</h4>
                        {data3.map((item, index) => (
                            <div className={`card bg_colors 
                            ${item.status_name === "Closed" ? 'bg-success' :
                                    item.status_name === "Hold" ? 'bg-warning' :
                                        item.status_name === "Lost" ? 'bg-danger' : 'bg_color02'}`}
                                key={index}>
                                <div className="card-body">
                                    <div className="box_splite">
                                        <div className="left_splite">
                                            <h3 className="box-head">{item.status_name}</h3>
                                        </div>
                                        <div className="right_splite">
                                            {item.cnt}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>



        </div>
    );
};

export default NumberOfBookings;
